export default {
  "content": "<g clip-path=\"url(#clip0_316_15616)\"><path d=\"M12.188 1.083H.812a.812.812 0 100 1.625h.271v8.938a.813.813 0 001.625 0V7.042h7.584v4.604a.813.813 0 001.625 0V2.708h.27a.812.812 0 100-1.625zM7.8 5.417H5.2a.84.84 0 01-.867-.813.84.84 0 01.867-.812h2.6a.84.84 0 01.867.812.84.84 0 01-.867.813z\" fill=\"#717684\"/></g><defs><clipPath id=\"clip0_316_15616\"><path fill=\"#fff\" d=\"M0 0h13v13H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "13",
    "height": "13",
    "viewBox": "0 0 13 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};